export enum AntibioticsIdentifiedFarmer {
    APPROVED='APPROVED',
    REJECTED = 'REJECTED'
}